export const MAIN_API = "https://api.aik.az/public/api/v1";
// export const MAIN_API = "http://127.0.0.1:8001/api/v1";


